import { render, staticRenderFns } from "./contact2.vue?vue&type=template&id=8fa0e0c0&scoped=true&"
import script from "./contact2.vue?vue&type=script&lang=js&"
export * from "./contact2.vue?vue&type=script&lang=js&"
import style0 from "./contact2.vue?vue&type=style&index=0&id=8fa0e0c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa0e0c0",
  null
  
)

export default component.exports